import * as React from "react"
import { cn } from "../../lib/utils"

interface ToggleProps {
  leftLabel: string
  rightLabel: string
  isRightActive: boolean
  onToggle: () => void
  className?: string
  labelClassName?: string
  disabled?: boolean
  forceRight?: boolean  // forces toggle to right position
  ariaLabel?: string    // accessible name for the switch button
  title?: string        // native tooltip on the switch button (e.g. why it is locked)
}

export const Toggle = ({ 
  leftLabel, 
  rightLabel, 
  isRightActive, 
  onToggle, 
  className, 
  labelClassName,
  disabled = false,
  forceRight = false,
  ariaLabel,
  title
}: ToggleProps) => {
  const effectivePosition = forceRight ? true : isRightActive;
  const isDisabled = disabled || forceRight;
  
  return (
    <div className={cn("", className)}>
      <span className={cn("mr-2 text-sm", labelClassName, isDisabled && "opacity-75")}>
        {leftLabel}
      </span>
      <button
        onClick={isDisabled ? undefined : onToggle}
        type="button"
        disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-label={ariaLabel}
        aria-pressed={effectivePosition}
        title={title}
        className={cn(
          "relative inline-flex h-6 w-11 items-center rounded-full bg-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2",
          isDisabled && "cursor-not-allowed opacity-75"
        )}
      >
        <span
          className={cn(
            "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
            effectivePosition ? "translate-x-6" : "translate-x-1"
          )}
        />
      </button>
      <span className={cn("ml-2 text-sm", labelClassName, isDisabled && "opacity-75")}>
        {rightLabel}
      </span>
    </div>
  );
}